/* tslint:disable:typedef-whitespace align no-trailing-whitespace import-spacing */

import {Action, ActionType}       from '@/models/action';
import {Logger}                   from '@/util/logger';
import {WindowService}            from "@/services/window.service";
import {StringLineViewerMetadata} from '@/screens/ide/string.line.viewer.metadata';


/**
 *
 * @class ScenarioBrowseAction
 *
 * @brief launch a new / blank scenario browser (tables view of scenario)
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      June 2020
 *
 */
export class StringLineViewAction extends Action {

  private      windows: WindowService = null;

  constructor(options: any = null) {

    super({
      key:   'window.stringlineview',
      type:  ActionType.Window_StringLineViewer,
      label: 'String Line Viewer (Empty)',
      icon:  '<i class="fas fa-train"></i>',
      tip:   'Launch a string line viewer'
    });

    this.windows  = this.injector().get(WindowService);
  }

  /* is this action enabled? */
  public enabled(): boolean {

    return true;
  }

  /** implement the action */
  public execute(): boolean {

    if (!this.enabled()) {
      return false;
    }

    Logger.debug('[ScenarioBrowseAction] executing...');

    this.windows.launchWindow(new StringLineViewerMetadata(
      '',
      '',
      '',
      ''
    ));

    return true;
  }
}
